import { Stack, Typography } from '@mui/material';

import { MyButton, MyDialog } from '../uiComponents';

interface TextInProgressDialogProps {
  error?: string;
  isResetting: boolean;
  onCancel: () => void;
  onClear: () => void;
  onContinue: () => void;
}

export const TextInProgressDialog = ({
  error,
  isResetting,
  onCancel,
  onClear,
  onContinue,
}: TextInProgressDialogProps) => (
  <MyDialog open dialogTitle='You have an unfinished listing draft' width='720'>
    <Typography color='#2a3842' component='p' fontWeight={400} lineHeight='24px' textAlign='center'>
      You have an unfinished listing draft. What would you like to do?
    </Typography>
    <Typography
      color='#6f7d87'
      component='p'
      fontWeight={400}
      lineHeight='24px'
      marginTop={1}
      textAlign='center'
    >
      Clearing the draft will remove its current content. You can also continue editing it or
      cancel.
    </Typography>
    {error && (
      <Typography color='error' component='p' marginTop={2} role='alert' textAlign='center'>
        {error}
      </Typography>
    )}
    <Stack
      alignItems={{ xs: 'stretch', sm: 'center' }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent='center'
      padding='30px 0 10px'
      spacing={2}
    >
      <MyButton
        data={{
          buttonName: isResetting ? 'Clearing...' : 'Clear draft',
          buttonType: 'button',
          customWidth: '170px',
          variant: 'contained',
        }}
        disabled={isResetting}
        onClick={onClear}
      />
      <MyButton
        data={{
          buttonName: 'Continue draft',
          buttonType: 'button',
          customWidth: '170px',
          styleType: 'cancel',
          variant: 'outlined',
        }}
        disabled={isResetting}
        onClick={onContinue}
      />
      <MyButton
        data={{
          buttonName: 'Cancel',
          buttonType: 'button',
          customWidth: '170px',
          styleType: 'cancel',
          variant: 'outlined',
        }}
        disabled={isResetting}
        onClick={onCancel}
      />
    </Stack>
  </MyDialog>
);
